import React from 'react';
import type { LinkProps as MuiLinkProps } from '@mui/material/Link';
import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Link: React.FC<MuiLinkProps> = ({ href, className, ...otherProps }) => {
  if (!href) {
    return <MuiLink className={className} {...otherProps} />;
  }

  const isInternalLink = href.startsWith('/') || href.startsWith(window.location.origin);

  if (isInternalLink) {
    return <MuiLink component={RouterLink} to={href} className={className} {...otherProps} />;
  }

  return <MuiLink href={href} rel='noopener noreferrer' className={className} {...otherProps} />;
};

export default Link;
